import { Component, OnInit, Input } from '@angular/core';
import { UserInfo } from '../userInfo';
import { DataService } from '../dataService.service';

@Component({
  selector: 'app-products-banner',
  templateUrl: './products-banner.component.html',
  styleUrls: ['./products-banner.component.css']
})
export class ProductsBannerComponent implements OnInit {

  @Input() UserInfos:UserInfo;
  public mapsData;
  constructor(private dataService: DataService) {


   }
   ngOnInit() {


  }

  ngOnChanges(UserInfos:any){
   if(UserInfos && UserInfos.Address){
     
   }
  }
}
